import { fromJS } from 'immutable';

import {
  FETCH_HOME_DATA,
  FETCH_HOME_DATA_SUCCESS,
  FETCH_HOME_DATA_ERROR,
} from './constants';

const initialState = fromJS({
  homeData: [],
  isLoading: false,
  fetchingHomeData: false,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HOME_DATA:
      return state.set('isLoading', true);
    // case FETCH_HOME_DATA_ERROR:
    //   return state.set('fetchingHomeData', false);
    case FETCH_HOME_DATA_SUCCESS:
      return state
        .set('homeData', fromJS(action.payload))
        .set('isLoading', false);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// client/containers/HomePage/reducer.js